class Organisation {
  constructor({
    organisationId,
    organisationType,
    organisationName,
    orgCountryCode,
    linkedOrganisations = [],
  }) {
    this.id = organisationId;
    this.type = organisationType;
    this.name = organisationName;
    this.countryCode = orgCountryCode;
    // Orgs linked to this one, as shipped by /auth/me. Only used to seed the
    // /organisations/<id>/asset-owners query so the primary org's Target list is instant.
    this.linkedOrganisations = linkedOrganisations;
  }

  isContractor() {
    return this.type === "Contractor";
  }

  isAssetOwner() {
    return this.type === "Asset_Owner";
  }

  toServerModel() {
    return {
      organisationId: this.id,
      organisationType: this.type,
      organisationName: this.name,
      orgCountryCode: this.countryCode,
    };
  }
}

export default Organisation;
